// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Index_loadingContainer__V2UiR","spinner":"Index_spinner__bDOOU","spin":"Index_spin__IuoRe","loadingText":"Index_loadingText__KyTpG","pulse":"Index_pulse__NniGe"};